<template>
    <div>
        <div class="page">
            <div class="app-navigation">
                <router-link :to="'/builder'" class="nav-link active">
                    <span class="icon icon-tools"></span>
                    <h4>Builder</h4>
                    <h5 class="beta">Alpha</h5>
                </router-link>
                <router-link :to="'/'" class="nav-link">
                    <span class="icon icon-tv"></span>
                    <h4>Desktops</h4>
                    <h5>Coming Soon</h5>
                </router-link>
                <router-link :to="'/'" class="nav-link">
                    <span class="icon icon-laptop"></span>
                    <h4>Laptops</h4>
                    <h5>Coming Soon</h5>
                </router-link>
                <router-link :to="'/'" class="nav-link">
                    <span class="icon icon-rss"></span>
                    <h4>Networking</h4>
                    <h5>Coming Soon</h5>

                </router-link>
            </div>
        </div>
    </div>
</template>
.<style scoped>
@import '../assets/css/builder.css';
@import '../assets/css/custom.css';

.beta {
 
}
span {
    font-size: 100px;
    color: #b2b3b4;
}
h5 {
    color: #434857;
}
.page {
    display: block;
    height: 100%;
    padding: 4%;

}
.app-navigation {
    
    display:block;
    text-align: center;
    
}
.nav-link {
    transition: 0.3s;
    padding-top: 40px;
    display: inline-block;
    margin-top: 25px;
    border: 1px solid #434857;
    height: 300px;
    margin-right: 25px;
    min-width: 200px;
    border-radius: 6px;
}
.nav-link:hover {
    border: 1px solid #1997c6;
}
.active {
    cursor: pointer;
}
.nav-link:hover .beta {
    color : #1BC98E 
}
.nav-link:hover h4, .nav-link:hover span {
    color: #1997c6 !important;
     transition: 0.3s;
}
</style>

<script>

export default ({
    name: 'AppHome'
})
</script>
